if (!customElements.get('islander-image-comparison')) {
  class IslanderImageComparison extends HTMLElement {
    connectedCallback() {
      if (this.range) return;

      this.range = this.querySelector('[data-image-comparison-range]');
      this.output = this.querySelector('[data-image-comparison-output]');
      if (!this.range) return;

      this.handleInput = () => this.update(this.range.value);
      this.range.addEventListener('input', this.handleInput);
      this.update(this.range.value);
    }

    disconnectedCallback() {
      this.range?.removeEventListener('input', this.handleInput);
      this.range = null;
      this.output = null;
    }

    update(value) {
      const numericValue = Number(value);
      const position = Math.round(Math.min(100, Math.max(0, Number.isFinite(numericValue) ? numericValue : 50)));

      this.style.setProperty('--comparison-position', `${position}%`);
      this.range.setAttribute('aria-valuenow', String(position));
      if (this.output) this.output.textContent = `${position}% of the before image revealed`;
    }
  }

  customElements.define('islander-image-comparison', IslanderImageComparison);
}
